import { ChartFacade } from '@mode/charts/contract';
import { CompiledField } from '@mode/shared/util-switch';
import { DomainLoader } from './colors-modal.component';

export class EmptyDomainLoader implements DomainLoader {
  fetchDomain(
    chartFacade: ChartFacade,
    currentField: CompiledField,
    onResult: (result: any[]) => void,
    onError: (error: string) => void
  ): void {
    // Empty encodings should only wind up here for a PTQC with Measure Names/Measure Values
    // Return an empty domain so the colors can at least be set.
    const emptyDomain = currentField.isContinuous ? [Number.NaN, Number.NaN] : [];
    onResult(emptyDomain);
  }
}
